import { EmptyData } from '@/components/lib/EmptyData'
import { Loading } from '@/components/lib/Loading'
import { EditFormModal } from '@/components/modal/BookingModal'
import useBooking from '@/hooks/use-booking'
import TableBooking from './TableBooking'

export const BookingSlotListTable = () => {

  const {
    setShow,
    bookings,
    loading,
    myRole,
    show,
    bookingInput,
    onSubmitLoading,
    handleShowEditForm,
    handleSubmit,
    handleDelete,
    handleUpdateState,
  } = useBooking()

    const editFormModalProps = {show, setShow, handleSubmit, onSubmitLoading, bookingInput}
    const tableBookingProps = { bookings, myRole, handleUpdateState, handleShowEditForm, handleDelete }
  
  /* Render
   *******************************************************************************************/
  return (
    <>
      {loading ? (
        <Loading />
      ) : bookings?.length === 0 ? (
        <EmptyData />
      ) : (
        <>
          <TableBooking tableBookingProps={tableBookingProps} />
          <EditFormModal editFormModalProps={editFormModalProps} />
        </>
      )}
    </>
  )
}
